import VoucherMain from './Main';

export default VoucherMain;